import { Mixin } from 'mixwith';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseRedactedNode(representation) {
        return {
          id: representation.attributes.enclosed_element.nodeValue,
          ignore: true,
        };
      }
    },
);
